export enum EmailMessageRecipientType {
  Bcc = 'Bcc',
  Cc = 'Cc',
  To = 'To',
}
